<template>
  <v-card class="elevation-7 print-card" :class="{'mobile-card': $vuetify.breakpoint.xsOnly}">
    <v-toolbar class="toolbar4 white--text remove-space-on-print">
      <v-toolbar-title>Dados do Ato</v-toolbar-title>
    </v-toolbar>
    <v-divider light></v-divider>
    <v-layout align-start row wrap class="remove-space-on-print">
      <v-flex xs8 :class="{'pt-0': $vuetify.breakpoint.name === 'sm'}">
        <v-card-title class="fix-margin-print">
          <div>
            <div>Ato Lavrado Em:</div>
            <div><b :class="$vuetify.breakpoint.name">{{dataFormatada(selo.atoMovimento.dataMovimento)}}</b></div>
            <div class="espaco-top">Tipo de Ato:</div>
            <div><b :class="$vuetify.breakpoint.name">{{selo.atoMovimento.descricao}}</b></div>
          </div>
        </v-card-title>
      </v-flex>
      <v-flex xs4 :class="{'pt-0': $vuetify.breakpoint.name === 'sm'}">
        <v-card-title class="fix-margin-print">
          <div>
            <div v-if="has('livro')" class="espaco-top">Livro:</div>
            <div v-if="has('livro')"><b :class="$vuetify.breakpoint.name">{{selo.atoMovimento.livro}}</b></div>
            <div v-if="has('folhaInicial')" class="espaco-top">Folhas:</div>
            <div v-if="has('folhaInicial')">
              <b :class="$vuetify.breakpoint.name">
                {{selo.atoMovimento.folhaInicial}} a
                {{selo.atoMovimento.folhaFinal}} 
              </b>
            </div>
          </div>
        </v-card-title>
      </v-flex>
    </v-layout>
    <v-layout align-start row wrap class="remove-space-on-print">
      <v-flex xs4 :class="{'pt-0': $vuetify.breakpoint.name === 'sm'}">
        <v-card-title class="fix-margin-print">
          <div v-if="has('atoMovimentoCampo')">
            <b :class="$vuetify.breakpoint.name">Campos informados:</b> 
          </div>
          <div v-if="has('atoMovimentoCampo')" v-for="campo in selo.atoMovimento.atoMovimentoCampo">
            <div class="espaco-top">{{campo.deCampo}}: <b :class="$vuetify.breakpoint.name">{{campo.valorCampo}}</b></div>
          </div>
        </v-card-title>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
  export default {
    name: 'DadosAtoCard',
    props: ['selo'],
    methods: {
      has: function (prop) {
        return !!this.selo.atoMovimento[prop];
      }
    }
  }
</script>
<style scoped>

  .inline {
    display: inline;
  }

  .toolbar4 {
    background: #2C397F;
  }

</style>



// WEBPACK FOOTER //
// src/components/detalhes/DadosAtoCard.vue